import axios from 'axios';

const baseURL = process.env.REACT_APP_API_HOST;

const axiosAuthClient = axios.create(
  
  {
    baseURL: baseURL,
    timeout: 5000,
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      // Credential: true,
      // 'Authorization': `Bearer ${token}`
    }
  })



export default axiosAuthClient;



